// import { LetterFormState, generateShortId } from "../types/letterhead.types.ts";
// import { dataURLtoFile } from "../hooks/letterheadMappers.ts";

// export const buildLetterPayload = (state: LetterFormState, cid: string, actionType: string, existingId: string | undefined, processedTemplate: any, idType: 'company_id' | 'user_id' = 'company_id') => {
//   const finalLetterId = existingId || generateShortId();
//   let iqCode = state.iqCode;
//   if (!iqCode || iqCode === finalLetterId || iqCode.length > 20) iqCode = generateShortId();

//   let fileToUpload = null;
//   let visualSrc = null;

//   if (state.signatureType === 'draw' && state.drawnSignature) {
//     fileToUpload = dataURLtoFile(state.drawnSignature, 'signature-drawn.png');
//     visualSrc = state.drawnSignature;
//   } else if (state.signatureType === 'upload' && state.uploadedSignatureFile) {
//     fileToUpload = state.uploadedSignatureFile;
//     visualSrc = URL.createObjectURL(state.uploadedSignatureFile);
//   } else if (state.uploadedSignatureUrl) {
//     visualSrc = state.uploadedSignatureUrl;
//   }

//   const qrEncoded = btoa(JSON.stringify({ iqCode, issuedBy: state.issuedBy, issuedTo: state.issuedTo, valid: "true" }));
//   const qrMeta = JSON.stringify({ enableQR: state.enableQR, iqCode: state.enableQR ? iqCode : "", issuedBy: state.issuedBy, token: qrEncoded }).replace(/"/g, '&quot;');
//   const templateSnapshot = processedTemplate ? btoa(encodeURIComponent(JSON.stringify(processedTemplate))) : "";

//   const fullHtmlBody = `
//     <div class="recipient-section">
//       <p><strong>To:</strong> ${state.recipientName}</p><p>${state.recipientAddress}</p><p>${state.recipientEmail}</p>
//     </div><br/>
//     <div class="letter-content">${state.body}</div><br/>
//     ${visualSrc ? `<div class="signature"><img src="${visualSrc}" alt="Signature" width="150"/></div>` : ''}
//     <div id="letter-meta-data" data-qr="${qrMeta}" data-template="${templateSnapshot}" style="display:none;"></div>
//   `;

//   let dbStatus = state.status ? state.status.toUpperCase() : "DRAFT";
//   if (actionType === 'SEND_LINK') {
//     dbStatus = state.signatories.every(sig => sig.status === 'SIGNED') ? "SIGNED" : "PENDING_SIGNATURE";
//   }

//   const idField = idType === 'user_id' ? { company_id: cid } : { company_id: cid };
//   // const idField =  { company_id: cid };
//   const payloadObj = {
//     letter_id: finalLetterId, ...idField, template_id: Number(state.templateId),
//     subject: state.subject || "Offer Letter", body: fullHtmlBody, status: dbStatus, iquique_code: state.enableQR ? iqCode : null,
//     letter_recipients: [{ name: state.recipientName, email: state.recipientEmail, address: state.recipientAddress }],
//     signature_setting: {
//       signature_type: state?.signatureType, verification_status: state.esignVerified ? "verified" : "pending",
//       verification_provider: state?.signatureType === 'esign' ? "AADHAAR_ESIGN" : null,
//       verification_reference: state?.esignReference || null, verification_signer_name: state.esignSignerName,

//       signatories: state?.signatureType === 'text'
//         ? state?.signatories?.map(sig => ({ role: sig.role, name: sig.name, email: sig.email, status: sig.status }))
//         : []
//     },
//     signature_placement: { type: state.signaturePlacement || 'last_page', page_from: parseInt(String(state.signaturePagePoint), 10) || 0, page_to: 0 }
//   };
//   // console.log("Constructed payload object:", payloadObj);

//   const formData = new FormData();
//   formData.append('data', JSON.stringify(payloadObj));
//   if (fileToUpload) formData.append('signatureFile', fileToUpload);

//   return { formData, finalLetterId, subject: state.subject, };
// };





// // src/pages/letterhead/utils/buildLetterPayload.ts
// // src/pages/letterhead/utils/buildLetterPayload.ts

// import { LetterFormState, generateShortId } from "../types/letterhead.types.ts";
// import { dataURLtoFile } from "../hooks/letterheadMappers.ts";

// export const buildLetterPayload = (
//   state: LetterFormState, 
//   cid: string, 
//   actionType: string, 
//   existingId: string | undefined, 
//   processedTemplate: any, 
//   idType: 'company_id' | 'user_id' = 'company_id'
// ) => {
//   const finalLetterId = existingId || generateShortId();
//   let iqCode = state.iqCode;
//   if (!iqCode || iqCode === finalLetterId || iqCode.length > 20) iqCode = generateShortId();

//   let fileToUpload = null;
//   let visualSrc = null;

//   if (state.signatureType === 'draw' && state.drawnSignature) {
//     fileToUpload = dataURLtoFile(state.drawnSignature, 'signature-drawn.png');
//     visualSrc = state.drawnSignature;
//   } else if (state.signatureType === 'upload' && state.uploadedSignatureFile) {
//     fileToUpload = state.uploadedSignatureFile;
//     visualSrc = URL.createObjectURL(state.uploadedSignatureFile);
//   } else if (state.uploadedSignatureUrl) {
//     visualSrc = state.uploadedSignatureUrl;
//   }

//   const qrEncoded = btoa(JSON.stringify({ 
//     iqCode, 
//     issuedBy: state.issuedBy, 
//     issuedTo: state.issuedTo, 
//     valid: "true" 
//   }));

//   const qrMeta = JSON.stringify({ 
//     enableQR: state.enableQR, 
//     iqCode: state.enableQR ? iqCode : "", 
//     issuedBy: state.issuedBy, 
//     token: qrEncoded 
//   }).replace(/"/g, '&quot;');

//   const templateSnapshot = processedTemplate 
//     ? btoa(encodeURIComponent(JSON.stringify(processedTemplate))) 
//     : "";

//   const fullHtmlBody = `
//     <div class="recipient-section">
//       <p><strong>To:</strong> ${state.recipientName || ''}</p>
//       <p>${state.recipientAddress || ''}</p>
//       <p>${state.recipientEmail || ''}</p>
//     </div>
//     <br/>
//     <div class="letter-content">${state.body || ''}</div>
//     <br/>
//     ${visualSrc ? `<div class="signature"><img src="${visualSrc}" alt="Signature" width="150"/></div>` : ''}
//     <div id="letter-meta-data" data-qr="${qrMeta}" data-template="${templateSnapshot}" style="display:none;"></div>
//   `;

//   let dbStatus = state.status ? state.status.toUpperCase() : "DRAFT";
//   if (actionType === 'SEND_LINK') {
//     dbStatus = state.signatories.every(sig => sig.status === 'SIGNED') ? "SIGNED" : "PENDING_SIGNATURE";
//   }

//   const idField = idType === 'user_id' ? { company_id: cid } : { company_id: cid };

//   // ============================================
//   // 🔥 FIX: Properly handle signatories for all signature types
//   // ============================================
//   let signatories = [];

//   // For 'send_link' type, always include signatories
//   if (state.signatureType === 'send_link') {
//     signatories = state.signatories
//       ?.filter(sig => sig.name && sig.name.trim() !== '' && sig.email && sig.email.trim() !== '')
//       .map(sig => ({
//         role: sig.role || 'Signatory',
//         name: sig.name.trim(),
//         email: sig.email.trim(),
//         status: sig.status || 'PENDING'
//       })) || [];
//   } 
//   // For 'text' type, include signatories if they exist
//   else if (state.signatureType === 'text' && state.signatories?.length > 0) {
//     signatories = state.signatories
//       ?.filter(sig => sig.name && sig.name.trim() !== '')
//       .map(sig => ({
//         role: sig.role || 'Signatory',
//         name: sig.name.trim(),
//         email: sig.email?.trim() || '',
//         status: sig.status || 'PENDING'
//       })) || [];
//   }
//   // For 'esign' type, include the esign signer
//   else if (state.signatureType === 'esign' && state.esignVerified) {
//     signatories = [{
//       role: 'Signatory',
//       name: state.esignSignerName || 'Signer',
//       email: state.recipientEmail || '',
//       status: 'SIGNED'
//     }];
//   }
//   // For 'upload' or 'draw', include signatories if manually added
//   else if (['upload', 'draw'].includes(state.signatureType) && state.signatories?.length > 0) {
//     signatories = state.signatories
//       ?.filter(sig => sig.name && sig.name.trim() !== '')
//       .map(sig => ({
//         role: sig.role || 'Signatory',
//         name: sig.name.trim(),
//         email: sig.email?.trim() || '',
//         status: sig.status || 'PENDING'
//       })) || [];
//   }

//   // If no signatories but we have recipient info, add as default signatory
//   if (signatories.length === 0 && state.recipientName && state.recipientName.trim() !== '') {
//     signatories = [{
//       role: 'Signatory',
//       name: state.recipientName,
//       email: state.recipientEmail || '',
//       status: 'PENDING'
//     }];
//   }

//   // ============================================
//   // 🔥 FIX: Build signature_setting WITHOUT verification_date
//   // ============================================
//   const signatureSetting: any = {
//     signature_type: state.signatureType || 'text',
//     verification_status: state.esignVerified ? "verified" : "pending"
//   };

//   // Only add verification_provider for esign
//   if (state.signatureType === 'esign') {
//     signatureSetting.verification_provider = "AADHAAR_ESIGN";
//   }

//   // Only add these if they exist
//   if (state.esignReference) {
//     signatureSetting.verification_reference = state.esignReference;
//   }

//   if (state.esignSignerName) {
//     signatureSetting.verification_signer_name = state.esignSignerName;
//   }

//   // Add signatories if they exist
//   if (signatories.length > 0) {
//     signatureSetting.signatories = signatories;
//   }

//   // ============================================
//   // BUILD FINAL PAYLOAD
//   // ============================================
//   const payloadObj = {
//     letter_id: finalLetterId,
//     ...idField,
//     template_id: Number(state.templateId),
//     subject: state.subject || "Offer Letter",
//     body: fullHtmlBody,
//     status: dbStatus,
//     iquique_code: state.enableQR ? iqCode : null,
//     letter_recipients: [{ 
//       name: state.recipientName || '', 
//       email: state.recipientEmail || '', 
//       address: state.recipientAddress || '' 
//     }],
//     signature_setting: signatureSetting,
//     signature_placement: { 
//       type: state.signaturePlacement || 'last_page', 
//       page_from: parseInt(String(state.signaturePagePoint), 10) || 0, 
//       page_to: 0 
//     }
//   };

//   // ============================================
//   // 🔥 FIX: Clean the payload - remove undefined and null values
//   // ============================================
//   const cleanObject = (obj: any) => {
//     Object.keys(obj).forEach(key => {
//       if (obj[key] === undefined || obj[key] === null) {
//         delete obj[key];
//       } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
//         cleanObject(obj[key]);
//         if (Object.keys(obj[key]).length === 0) {
//           delete obj[key];
//         }
//       }
//     });
//     return obj;
//   };

//   // Deep clean the payload
//   const cleanedPayload = cleanObject(payloadObj);

//   // 🔥 Ensure verification_date is never present
//   if (cleanedPayload.signature_setting) {
//     delete cleanedPayload.signature_setting.verification_date;

//     // If signatories array is empty, remove it
//     if (cleanedPayload.signature_setting.signatories?.length === 0) {
//       delete cleanedPayload.signature_setting.signatories;
//     }
//   }

//   // Debug log - Remove in production
//   console.log('📝 Final Cleaned Payload:', JSON.stringify(cleanedPayload, null, 2));

//   const formData = new FormData();
//   formData.append('data', JSON.stringify(cleanedPayload));
//   if (fileToUpload) formData.append('signatureFile', fileToUpload);

//   return { 
//     formData, 
//     finalLetterId, 
//     subject: state.subject,
//     payload: cleanedPayload
//   };
// };

// src/pages/letterhead/utils/buildLetterPayload.ts

import { LetterFormState, generateShortId } from "../types/letterhead.types.ts";
import { dataURLtoFile } from "../hooks/letterheadMappers.ts";

export const buildLetterPayload = (
  state: LetterFormState,
  cid: string,
  actionType: string,
  existingId: string | undefined,
  processedTemplate: any,
  idType: 'company_id' | 'user_id' = 'company_id'

) => {
  const finalLetterId = existingId || generateShortId();
  let iqCode = state.iqCode;
  if (!iqCode || iqCode === finalLetterId || iqCode.length > 20) iqCode = generateShortId();

  let fileToUpload = null;
  let visualSrc = null;

  if (state.signatureType === 'draw' && state.drawnSignature) {
    fileToUpload = dataURLtoFile(state.drawnSignature, 'signature-drawn.png');
    visualSrc = state.drawnSignature;
  } else if (state.signatureType === 'upload' && state.uploadedSignatureFile) {
    fileToUpload = state.uploadedSignatureFile;
    visualSrc = URL.createObjectURL(state.uploadedSignatureFile);
  } else if (state.uploadedSignatureUrl) {
    visualSrc = state.uploadedSignatureUrl;
  }

  const qrEncoded = btoa(JSON.stringify({
    iqCode,
    issuedBy: state.issuedBy,
    issuedTo: state.issuedTo,
    valid: "true"
  }));

  const qrMeta = JSON.stringify({
    enableQR: state.enableQR,
    iqCode: state.enableQR ? iqCode : "",
    issuedBy: state.issuedBy,
    token: qrEncoded
  }).replace(/"/g, '&quot;');

  const templateSnapshot = processedTemplate
    ? btoa(encodeURIComponent(JSON.stringify(processedTemplate)))
    : "";

  // ============================================
  // 🔥 FIX 1: Ensure recipient data is properly passed
  // ============================================
  const recipientName = state.recipientName?.trim() || '';
  const recipientEmail = state.recipientEmail?.trim() || '';
  const recipientAddress = state.recipientAddress?.trim() || '';

  // Log what we're getting
  console.log('📝 State Recipient Name:', state.recipientName);
  console.log('📝 State Recipient Email:', state.recipientEmail);
  console.log('📝 State Recipient Address:', state.recipientAddress);

  const fullHtmlBody = `
    <div class="recipient-section">
      <p><strong>To:</strong> ${recipientName}</p>
      <p>${recipientAddress}</p>
      <p>${recipientEmail}</p>
    </div>
    <br/>
    <div class="letter-content">${state.body || ''}</div>
    <br/>
    ${visualSrc ? `<div class="signature"><img src="${visualSrc}" alt="Signature" width="150"/></div>` : ''}
    <div id="letter-meta-data" data-qr="${qrMeta}" data-template="${templateSnapshot}" style="display:none;"></div>
  `;

  let dbStatus = state.status ? state.status.toUpperCase() : "DRAFT";
  if (actionType === 'SEND_LINK') {
    const allSigned = state.signatories?.every(sig => sig.status === 'SIGNED');
    dbStatus = allSigned ? "SIGNED" : "PENDING_SIGNATURE";
  }

  const idField = idType === 'user_id' ? { company_id: cid } : { company_id: cid };

  // ============================================
  // 🔥 FIX 2: Properly handle signatories for "Send Signing Link"
  // ============================================
  let signatories = [];

  // For 'send_link' type - ALWAYS include ALL signatories with name and email
  if (state.signatureType === 'send_link') {
    // Get all signatories from state
    const allSignatories = state.signatories || [];

    // Filter and map signatories - require both name AND email for send_link
    signatories = allSignatories
      .filter(sig => {
        const hasName = sig.name && sig.name.trim() !== '';
        const hasEmail = sig.email && sig.email.trim() !== '';
        return hasName && hasEmail; // Both required for send_link
      })
      .map(sig => ({
        role: sig.role || 'Signatory',
        name: sig.name.trim(),
        email: sig.email.trim(),
        status: sig.status || 'PENDING'
      }));

    // 🔥 Log for debugging
    console.log('📝 Send Link Signatories:', signatories);
    console.log('📝 All Signatories from state:', allSignatories);
  }
  // For 'text' type, include signatories if they exist
  else if (state.signatureType === 'text' && state.signatories?.length > 0) {
    signatories = state.signatories
      ?.filter(sig => sig.name && sig.name.trim() !== '')
      .map(sig => ({
        role: sig.role || 'Signatory',
        name: sig.name.trim(),
        email: sig.email?.trim() || '',
        status: sig.status || 'PENDING'
      })) || [];
  }
  // For 'esign' type, include the esign signer
  else if (state.signatureType === 'esign' && state.esignVerified) {
    signatories = [{
      role: 'Signatory',
      name: state.esignSignerName || 'Signer',
      email: recipientEmail || '',
      status: 'SIGNED'
    }];
  }
  // For 'upload' or 'draw', include signatories if manually added
  else if (['upload', 'draw'].includes(state.signatureType) && state.signatories?.length > 0) {
    signatories = state.signatories
      ?.filter(sig => sig.name && sig.name.trim() !== '')
      .map(sig => ({
        role: sig.role || 'Signatory',
        name: sig.name.trim(),
        email: sig.email?.trim() || '',
        status: sig.status || 'PENDING'
      })) || [];
  }

  // If no signatories but we have recipient info, add as default signatory
  // This is the fallback for non-send_link types
  if (signatories.length === 0 && recipientName  && recipientEmail) {
    signatories = [{
      role: 'Signatory',
      name: recipientName,
      email: recipientEmail || '',
      status: 'PENDING'
    }];
  }

  // ============================================
  // 🔥 FIX 3: Build signature_setting WITHOUT verification_date
  // ============================================
  const signatureSetting: any = {
    signature_type: state.signatureType || 'text',
    verification_status: state.esignVerified ? "verified" : "pending"
  };

  // Only add verification_provider for esign
  if (state.signatureType === 'esign') {
    signatureSetting.verification_provider = "AADHAAR_ESIGN";
  }

  // Only add these if they exist
  if (state.esignReference) {
    signatureSetting.verification_reference = state.esignReference;
  }

  if (state.esignSignerName) {
    signatureSetting.verification_signer_name = state.esignSignerName;
  }

  // 🔥 Always add signatories if they exist (especially important for send_link)
  if (signatories.length > 0) {
    signatureSetting.signatories = signatories;
  }

  // ============================================
  // BUILD FINAL PAYLOAD
  // ============================================
  const payloadObj = {
    letter_id: finalLetterId,
    ...idField,
    template_id: Number(state.templateId),
    subject: state.subject || "Offer Letter",
    body: fullHtmlBody,
    status: dbStatus,
    iquique_code: state.enableQR ? iqCode : null,
    // 🔥 Ensure recipient data is always passed
    letter_recipients: [{
      name: recipientName || 'Recipient',
      email: recipientEmail || '',
      address: recipientAddress || ''
    }],
    signature_setting: signatureSetting,
    signature_placement: {
      type: state.signaturePlacement || 'last_page',
      page_from: parseInt(String(state.signaturePagePoint), 10) || 0,
      page_to: 0
    }
  };

  // ============================================
  // CLEAN THE PAYLOAD
  // ============================================
  const cleanObject = (obj: any) => {
    Object.keys(obj).forEach(key => {
      if (obj[key] === undefined || obj[key] === null) {
        delete obj[key];
      } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        cleanObject(obj[key]);
        if (Object.keys(obj[key]).length === 0) {
          delete obj[key];
        }
      }
    });
    return obj;
  };

  // Deep clean the payload
  const cleanedPayload = cleanObject(payloadObj);

  // 🔥 Ensure verification_date is never present
  if (cleanedPayload.signature_setting) {
    delete cleanedPayload.signature_setting.verification_date;

    // If signatories array is empty, remove it
    if (cleanedPayload.signature_setting.signatories?.length === 0) {
      delete cleanedPayload.signature_setting.signatories;
    }
  }

  // ============================================
  // 🔥 DEBUG LOGS - Check what's being sent
  // ============================================
  console.log('📝 Recipient Name:', recipientName);
  console.log('📝 Recipient Email:', recipientEmail);
  console.log('📝 Recipient Address:', recipientAddress);
  console.log('📝 Signatories:', signatories);
  console.log('📝 Signature Type:', state.signatureType);
  console.log('📝 Final Cleaned Payload:', JSON.stringify(cleanedPayload, null, 2));

  const formData = new FormData();
  formData.append('data', JSON.stringify(cleanedPayload));
  if (fileToUpload) formData.append('signatureFile', fileToUpload);

  return {
    formData,
    finalLetterId,
    subject: state.subject,
    payload: cleanedPayload
  };
};